/**
 * @license
 * Copyright 2014 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Load the correct language pack and code bundle.
 * @author fraser@google.com (Neil Fraser)
 */
'use strict';

(function () {
  // Load the chosen language pack.
  var script = document.createElement('script');
  script.src =
    '/assets/js/blockly/movie/msg/' + window['BlocklyGamesLang'] + '-9cf7f84e.js';
  document.head.appendChild(script);
  // Load the code bundle for the chosen game.
  var script = document.createElement('script');
  script.src = '/assets/js/blockly/movie/minified-9cf7f84e.js';
  document.head.appendChild(script);
})();
